import { Grid, Typography } from "@material-ui/core";
import moment from "moment/moment";
import { dateLabels } from "../../ContasPagarConstants";
import { useContasPagarService } from "../../context/ContasPagarContext";

export const ReportHeader = () => {
  const { cachedPeriod: period, filters } = useContasPagarService();

  return (
    <Grid item xs>
      <Typography variant="h4">Relatório de Contas a Pagar</Typography>

      <Typography variant="subtitle2">
        Contas a pagar {dateLabels[filters.dateFilter]} entre:{" "}
        {moment(period?.startDate, filters.period === "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        )}{" "}
        e{" "}
        {moment(period?.endDate, filters.period === "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        )}
      </Typography>
    </Grid>
  );
};
